import { render, staticRenderFns } from "./InputTextArea.vue?vue&type=template&id=5fd49a01"
import script from "./input-text-area.js?vue&type=script&lang=js&external"
export * from "./input-text-area.js?vue&type=script&lang=js&external"
import style0 from "./input-text-area.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports